import { validateCompliance } from "utils";

export const formFields = [

    {
      label: 'Σε περίπτωση ένταξης, ο  Δικαιούχος Φορέας οφείλει να υλοποιεί την επένδυση σύμφωνα με όσα προβλέπονται στην Πρόσκληση του Προγράμματος.',
      id: 'terms1',
      name: 'terms1',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Ο Δικαιούχος Φορέας οφείλει να παρέχει όλα τα ζητούμενα στοιχεία και δικαιολογητικά για την αποτίμηση της επίτευξης των στόχων.',
      id: 'terms2',
      name: 'terms2',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Οι προς χρηματοδότηση επενδύσεις στο πλαίσιο του προγράμματος θα πρέπει να αφορούν αποκλειστικά τις υπηρεσίες ύδρευσης και αποχέτευσης τις οποίες παρέχει ο Δικαιούχος Φορέας κατ΄ αποκλειστικότητα στη γεωγραφική περιοχή αρμοδιότητάς τους. Σε περίπτωση που ο Δικαιούχος Φορέας ασκεί άλλες οικονομικές δραστηριότητες πλην της ύδρευσης και της αποχέτευσης, (δυνατότητα που παρέχεται από τον ιδρυτικό του νόμο), απαιτείται να τηρεί χωριστούς λογαριασμούς προκειμένου να αποφεύγεται η διεπιδότηση των εν λόγω δραστηριοτήτων από τους πόρους του Προγράμματος.',
      id: 'terms3',
      name: 'terms3',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Ο Δικαιούχος Φορέας οφείλει να τηρεί ξεχωριστή λογιστική μερίδα για την πράξη ή να διαθέτει επαρκή λογιστική κωδικοποίηση από την οποία να προκύπτει η καταχώρηση όλων των δαπανών που αντιστοιχούν πλήρως προς τις δαπάνες που δηλώνονται.',
      id: 'terms4',
      name: 'terms4',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Για τον έλεγχο των μακροχρονίων υποχρεώσεων, ο Δικαιούχος Φορέας, πρέπει να αποστέλλει στο Φορέα Υλοποίησης και Ελέγχου όλα τα σχετικά έγγραφα όταν ζητηθούν εγγράφως από αυτόν.',
      id: 'terms5',
      name: 'terms5',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Ο Δικαιούχος Φορέας επιβεβαιώνει ότι έχει λάβει γνώση για την τήρηση της αποφυγής διπλής χρηματοδότησης και δεν έχει λάβει χρηματοδότηση από άλλους ενωσιακούς πόρους για τον ίδιο εξοπλισμό.',
      id: 'terms6',
      name: 'terms6',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    },
    {
      label: 'Η άντληση των στοιχείων των Δικαιούχων Φορέων για την ταυτοποίησή τους,διενεργείται μέσω διαλειτουργικότητας από το Μητρώο Φορολογουμένων της ΑΑΔΕ για το οποίο λαμβάνουν γνώση και συναινούν.',
      id: 'terms7',
      name: 'terms7',
      type: 'checkbox',
      rules: [
        {
          type: 'boolean',
          transform: value => value || undefined,
        },
        { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
        () => ({
          validator(_, value) {
            return validateCompliance(value);
          },
        }),
      ],
      asterisk: true,
    }
    
  ];